import React, { Fragment } from 'react';
import { array, func, object } from 'prop-types';

import BackToTop from './BackToTop';
import Hotels from './Hotels';

function HotelsByCountry({
  groupByCountry,
  mapHeader,
  mapWrap,
  selectLocationMap
}) {
  function scrollTopMap() {
    mapWrap.current.scrollTop = 0;
    mapHeader.current.scrollIntoView({
      block: 'end',
      inline: 'nearest'
    });
  }

  return (
    <div className="cell large-4 filtered-hotels">
      <div className="find-a-hotel-suggestions">
        <Fragment>
          {/*
              Fragment allows multiple elements to render without a parent div.
              It may only be necessary if a parent div would impact styling,
              but it also avoids div > div > div in the DOM
            */}
          {groupByCountry.map((group, index) => {
            return (
              <Fragment key={index}>
                <Hotels
                  country={group.country}
                  filtered={group.places}
                  selectLocation={selectLocationMap}
                  destinationMap={false}
                />
              </Fragment>
            );
          })}
          <BackToTop scrollTop={scrollTopMap} />
        </Fragment>
      </div>
    </div>
  );
}

HotelsByCountry.propTypes = {
  filtered: array.isRequired,
  groupByCountry: array.isRequired,
  mapHeader: object.isRequired,
  mapWrap: object.isRequired,
  selectLocationMap: func.isRequired
};

export default HotelsByCountry;
